import { georgeStats } from '@shared/statistics';

function getOriginTime(): number | undefined {
    return window.performance?.timeOrigin ?? window.performance?.timing?.navigationStart;
}

function getTimeFromOrigin(): number {
    const timeOrigin = getOriginTime();
    if (!timeOrigin) {
        return 0;
    }

    return Math.round(new Date().valueOf() - timeOrigin);
}

export function trackPageLoadPerformace(): void {
    georgeStats.trackEvent('performance', 'initialLoadTime', {
        timeFromOrigin: getTimeFromOrigin(),
    });
}
